export default "__VITE_ASSET__CcFsYmEw__"